import { adapter } from "@hg/adapt-sdk"
import { getSDKReadyFunc } from "@hg/hg-web-sdk"

import Toast from "@/topic/rogue_5/components/Toast"

adapter.init()
export { adapter }

const ETL_OPTION = {
    domain: "arknights",
    sub_domain: "activity",
    third_domain: "roguelike",
    pageProperties: {
        language: __LOCALE,
        source: adapter.source.from || "",
        share_type: adapter.share.type || "",
        share_by: adapter.share.by || "",
    },
}

export const sdkReady = getSDKReadyFunc(__SDK_SRC, {
    etl: ETL_OPTION,
})

if (__SDK_HOST) {
    sdkReady((sdk) => {
        sdk.hostConfig.u8Server.setHost(__SDK_HOST)
        sdk.hostConfig.hgServer.setHost(__SDK_HOST)
    })
}

export const analyticsEvent = async (
    eventName: string,
    params: Record<string, string>
) => {
    // const sdk = await sdkReady()
    // const analytics = sdk.Analytics.get()
    // analytics?.event(eventName, params)
}

export async function collect(
    event: string,
    properties: Record<string, unknown>
) {
    // const sdk = await sdkReady()
    // sdk.ETL.event(event, properties)
}

import WebSDK from "@yo-star/websdk"

import configJson from "../../SDKConfigSettings.json"
import {
    accountSignIn,
    accountSignInfo,
    accountSignOut,
} from "../topic/rogue_5/service"

const webSDK = new WebSDK(configJson)
let initPromise: Promise<boolean> | null = null

export const webSdkReady = () => {
    if (!initPromise) {
        initPromise = webSDK.Init({ PID: "US-ARKNIGHTS" }).then((res) => {
            return res.code === 0
        })
    }
    return initPromise
}

let isLoggingIn = false
export const webLogin = async (dispatch: React.Dispatch<any>) => {
    if (isLoggingIn) {
        return
    }
    isLoggingIn = true
    try {
        const isReady = await webSdkReady()
        if (isReady) {
            const res = await webSDK.Login()
            if (res.code === 0) {
                const { code, data, msg } = await accountSignIn(
                    res.data?.LOGIN_UID || "",
                    res.data?.LOGIN_TOKEN || ""
                )

                if (code === 0) {
                    const userData = {
                        uid: (data as any)?.sdkuid || "",
                        nickName: (data as any)?.nickName || "",
                    }
                    const accountRes = await accountSignInfo()
                    // console.log(accountRes)
                    dispatch({
                        type: "updateContext",
                        payload: {
                            user: userData,
                        },
                    })

                    return userData
                } else {
                    Toast.message({ content: msg })
                    // set({ loginLoading: false })
                    webLogout()
                    return false
                }
            } else {
                Toast.message({ content: res.msg })
            }
        }
    } finally {
        isLoggingIn = false
    }
}
export const webLogout = async () => {
    await webSDK.Logout()
    accountSignOut()
}
